import { render, staticRenderFns } from "./ElectronicRedactions.vue?vue&type=template&id=3385d8ec&scoped=true&"
import script from "./ElectronicRedactions.vue?vue&type=script&lang=js&"
export * from "./ElectronicRedactions.vue?vue&type=script&lang=js&"
import style0 from "./ElectronicRedactions.vue?vue&type=style&index=0&id=3385d8ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3385d8ec",
  null
  
)

export default component.exports